<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                            (click)="abrirDialog()"
                        ></button>
                    </div>
                    <div class="field col-12 md:col-2 flex justify-content-end">
                        <button
                            pButton
                            pRipple
                            label="Finalizar"
                            icon="pi pi-check"
                            class="p-button-success p-button-outlined sm:w-9rem"
                            (click)="finalizarFolha()"
                            [disabled]="folhaProcessada"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="listaContratosFolha"
                dataKey="contratoId"
                [expandedRowKeys]="expandedRows"
                styleClass=" p-datatable-sm"
                responsiveLayout="scroll"
                [loading]="loading"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row w-full">
                            <div class="p-fluid sm:w-12rem sm:mr-2">
                                <label htmlFor="filtroData">Competência</label>
                                <p-calendar
                                    placeholder="Selecione"
                                    view="month"
                                    dateFormat="mm/yy"
                                    [showIcon]="true"
                                    [readonlyInput]="true"
                                    [(ngModel)]="filtroCompetencia"
                                    (ngModelChange)="filtrar()"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Contrato</label>
                                <p-dropdown
                                    [options]="listaContratos"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="contratoSelecionado"
                                    (onChange)="filtrar()"
                                ></p-dropdown>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Profissional</label>
                                <p-dropdown
                                    [options]="listaProfissionais"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="profissionalSelecionado"
                                    (onChange)="filtrar()"
                                ></p-dropdown>
                            </div>
                        </div>
                        <div class="p-fluid mt-3 sm:mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex justify-content-center flex-row py-1 mt-2"
                        *ngIf="folhaProcessada && listaContratosFolha.length > 0"
                    >
                        <span class="text-gray-600">
                            <i class="pi pi-check"></i>
                            Folha processada nesta competência
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="body" let-contrato let-expanded="expanded">
                    <tr class="bg-blue-50">
                        <td>
                            <button
                                type="button"
                                pButton
                                pRipple
                                [pRowToggler]="contrato"
                                class="p-button-text p-button-rounded p-button-plain"
                                style="box-shadow: none"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            ></button>
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            {{ contrato.razaoSocial }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            <span class="mr-1">Vencimentos:</span>
                            {{ contrato.receitas | currency: "BRL" }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold">
                            <span class="mr-1">Descontos:</span>
                            {{ contrato.descontos | currency: "BRL" }}
                        </td>
                        <td style="min-width: 12rem" class="text-lg font-semibold text-end">
                            <span class="mr-1">Valor Líquido:</span>
                            {{ contrato.valorLiquido | currency: "BRL" }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-contrato>
                    <tr class="surface-hover">
                        <td colspan="7">
                            <div class="p-3">
                                <p-table
                                    [value]="contrato.profissionais"
                                    dataKey="profissionalId"
                                    styleClass=" p-datatable-sm"
                                    responsiveLayout="scroll"
                                >
                                    <ng-template
                                        pTemplate="body"
                                        let-profissional
                                        let-expanded="expanded"
                                    >
                                        <tr class="surface-hover">
                                            <td>
                                                <button
                                                    type="button"
                                                    pButton
                                                    pRipple
                                                    [pRowToggler]="profissional"
                                                    class="p-button-text p-button-rounded p-button-plain"
                                                    style="box-shadow: none"
                                                    [icon]="
                                                        expanded
                                                            ? 'pi pi-chevron-down'
                                                            : 'pi pi-chevron-right'
                                                    "
                                                ></button>
                                            </td>
                                            <td>
                                                {{ profissional.nomeProfissional }} -
                                                {{ profissional.descricaoTipoProfissional }}
                                            </td>
                                            <td style="min-width: 12rem">
                                                <span class="mr-1">Vencimentos:</span>
                                                {{ profissional.receitas | currency: "BRL" }}
                                            </td>
                                            <td style="min-width: 12rem">
                                                <span class="mr-1">Descontos:</span>
                                                {{ profissional.descontos | currency: "BRL" }}
                                            </td>
                                            <td
                                                style="min-width: 12rem"
                                                *ngIf="profissional.tipoProfissional === 1"
                                            >
                                                <span class="mr-1">Valor Líquido:</span>
                                                {{
                                                    profissional.valorLiquido +
                                                        contrato.saldoContrato | currency: "BRL"
                                                }}
                                            </td>
                                            <td
                                                style="min-width: 12rem"
                                                *ngIf="profissional.tipoProfissional === 0"
                                            >
                                                <span class="mr-1">Valor Líquido:</span>
                                                {{ profissional.valorLiquido | currency: "BRL" }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="6">Nenhum registro encontrado.</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="rowexpansion" let-profissional>
                                        <tr class="surface-hover">
                                            <td colspan="7">
                                                <div class="p-3">
                                                    <p-table
                                                        [value]="profissional.registrosFolha"
                                                        dataKey="registroFolhaId"
                                                        responsiveLayout="scroll"
                                                        styleClass="p-datatable-striped"
                                                    >
                                                        <ng-template pTemplate="body" let-registro>
                                                            <tr class="surface-hover font-italic">
                                                                <td style="min-width: 3rem"></td>
                                                                <td>
                                                                    {{ registro.descricao }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        registro.dataRegistro
                                                                            | date: "dd/MM/yyyy"
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{ registro.parcela }}
                                                                </td>
                                                                <td>
                                                                    {{ registro.tipoRegistro }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        registro.valorRegistro
                                                                            | currency: "BRL"
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        *ngIf="
                                                                            permissaoExcluir &&
                                                                            !registro.folhaProcessada
                                                                        "
                                                                        pButton
                                                                        pRipple
                                                                        pTooltip="Excluir"
                                                                        (click)="
                                                                            excluirItemFolha(
                                                                                registro.registroFolhaId
                                                                            )
                                                                        "
                                                                        icon="pi pi-trash"
                                                                        class="p-button-danger mb-2"
                                                                    ></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="emptymessage">
                                                            <tr>
                                                                <td colspan="6">
                                                                    There are no order for this
                                                                    product yet.
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
<p-dialog
    header="Folha Finalizada"
    [(visible)]="exibirFolhaFinalizada"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
>
    <div class="flex justify-content-between">
        <p>A folha da competência {{ competenciaFormatada }} foi finalizada</p>
        <button
            type="button"
            pButton
            label="OK"
            class="p-button-primary shadow-none"
            (click)="exibirFolhaFinalizada = !exibirFolhaFinalizada"
        ></button>
    </div>
</p-dialog>
<p-dialog
    header="Novo"
    [(visible)]="exibirDialog"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
>
    <ng-template pTemplate="content">
        <div class="flex justify-content-center" *ngIf="loadingDialog">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="p-fluid grid" *ngIf="!loadingDialog">
            <div class="field col-6">
                <label>Competência</label>
                <p-calendar
                    placeholder="Selecione"
                    view="month"
                    dateFormat="mm/yy"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    [(ngModel)]="filtroCompetenciaDialog"
                    appendTo="body"
                    (ngModelChange)="buscarDadosLancamentos()"
                ></p-calendar>
            </div>
            <div class="field col-6">
                <label>Plano Conta</label>
                <p-dropdown
                    [options]="listaPlanoConta"
                    placeholder="Selecione"
                    optionLabel="label"
                    optionValue="value"
                    emptyMessage="Nenhum registro"
                    [(ngModel)]="planoContaSelecionado"
                    appendTo="body"
                    (ngModelChange)="buscarDadosLancamentos()"
                ></p-dropdown>
            </div>
            <div class="col-12">
                <p-table
                    #dt2
                    [value]="listaLancamentosFolha"
                    [rows]="10"
                    [rowHover]="true"
                    styleClass="p-datatable-gridlines"
                    [paginator]="true"
                    [loading]="loadingTableDialog"
                    responsiveLayout="scroll"
                    styleClass=" p-datatable-sm"
                    [globalFilterFields]="['itemServico.descricao', 'rateio', '']"
                    [(selection)]="listaLancamentosFolhaSelecionados"
                    selectionMode="multiple"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th>
                                <div>Nome</div>
                            </th>
                            <th>
                                <div>Valor Lançamento</div>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="item" inputId="{{ i }}"></p-tableCheckbox>
                            </td>
                            <td>
                                <label>{{ item.nomeProfissional }}</label>
                            </td>
                            <td>
                                <p-inputNumber
                                    *ngIf="planoContaSelecionado?.codigo !== 25; else exibirLabel"
                                    name="valorRegistro{{ i }}"
                                    ngModel
                                    #valorRegistro="ngModel"
                                    [(ngModel)]="item.valorRegistro"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                ></p-inputNumber>
                                <ng-template #exibirLabel>
                                    <label>{{ item.valorRegistro | currency: "BRL" }}</label>
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div *ngIf="!loadingDialog" class="p-fluid p-formgrid grid justify-content-between">
            <div class="col-12 md:col-4 margem-zero-field">
                <button
                    type="button"
                    pButton
                    [icon]="
                        progressoRequisicaoSalvarDialog ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                    "
                    label="Salvar"
                    class="p-button-success"
                    [disabled]="
                        progressoRequisicaoSalvarDialog ||
                        listaLancamentosFolhaSelecionados.length < 1
                    "
                    (click)="salvarLancamentosFolha()"
                ></button>
            </div>
            <div class="col-12 md:col-4 margem-zero-field">
                <button
                    type="button"
                    pButton
                    icon="pi pi-times"
                    label="Cancelar"
                    class="p-button-danger"
                    (click)="exibirDialog = false"
                ></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
